import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

interface TalentScoreCardTableProps {
  coreSkillLabel: string;
}

const LEVELS = ['Beginner', 'Intermediate', 'Advanced', 'Pro'] as const;

const TIER_BANDS = [
  { tier: 'Emerging (Grade C)', range: '0%-49%', rowBg: '#f3f7ff' },
  { tier: 'Development (Grade B)', range: '50%-69%', rowBg: '#fff8e1' },
  { tier: 'Performance (Grade A)', range: '70%+', rowBg: '#edf7ed' },
] as const;

export function TalentScoreCardTable({ coreSkillLabel }: TalentScoreCardTableProps) {
  const rows = LEVELS.flatMap((level) =>
    TIER_BANDS.map((tierBand) => ({
      category: `${level} - ${tierBand.tier}`,
      scoreRange: tierBand.range,
      skill: '',
      drills: '',
      fitness: '',
      rowBg: tierBand.rowBg,
    }))
  );

  return (
    <>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
        Competitive tiers use placeholder score bands for now: Emerging (Grade C) `0%-49%`, Development (Grade B) `50%-69%`, and Performance (Grade A) `70%+`.
      </Typography>
      <TableContainer sx={{ border: '1px solid #dbe8f6', borderRadius: 1, bgcolor: '#fff' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#f7fbff' }}>
              <TableCell sx={{ fontWeight: 700 }}>Category</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Score Range</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>{coreSkillLabel}</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Drills</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Fitness</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.category} sx={{ bgcolor: row.rowBg }}>
                <TableCell sx={{ fontWeight: 600 }}>{row.category}</TableCell>
                <TableCell>{row.scoreRange}</TableCell>
                <TableCell>{row.skill}</TableCell>
                <TableCell>{row.drills}</TableCell>
                <TableCell>{row.fitness}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
